// 実費処理
$(() => {
    if ($("#operation-table") != null) {
        // 追加費用テーブル構築
        updateOperationTableButtons();
        $(document).on("click", '.js-remove-operation', e => {
            e.preventDefault();
            let tr = $('.js-operation-table-body .js-data-row');
            if (tr.length > 1) {
                $(e.currentTarget).closest('.js-data-row').remove();
                updateOperationTableButtons();
            } else {
                // 最後の1行の時は値のみクリアする
                $(e.currentTarget).closest('.js-data-row').find('input, textarea').each((i, element) => {
                    $(element).val('');
                    $(element).height('auto');
                });
                $(e.currentTarget).closest('.js-data-row').find('select').val('');
            }
        });

        $(document).on("click", '.js-add-operation', e => {
            e.preventDefault();
            let template = $('.js-operation-table-body .js-data-row').last();
            let row = template.clone(true);
            let id = $(e.currentTarget).parents("tr").data('id') + 1;

            // idを設定
            row.attr('data-id', id);
            $(row.find('select')).attr('id', 'report_content_dates' + id);
            $(row.find('textarea[name="report_contents[]"]')).attr('id', 'report_contents' + id);
            $(row.find('input[name="report_content_ids[]"]')).attr('id', 'report_content_ids' + id);
            $($(row).find('input, textarea')).removeClass('is-invalid');

            // valueの初期化
            row.find('input, textarea').each(function(){
                $(this).val('');
                $(this).height('auto');
            });
            $(row.find('select')).val('');

            $('.js-operation-table-body').append(row);
            updateOperationTableButtons();
        });

        // テーブルのボタンを更新
        function updateOperationTableButtons() {
            var monthly = $('.js-operation-table-body .js-data-row');
            for(var i = 0; i < monthly.length; i++) {
                let ctrls = $(monthly.get(i)).find('.js-ctrls');
                ctrls.html('');
                ctrls.append('<a href="#" class="js-remove-operation"><i class="fas fa-trash"></i></a>');
                if (i == monthly.length - 1) {
                    // 最後のみ追加ボタンをつける
                    ctrls.append('<a href="#" class="js-add-operation"><i class="fas fa-plus"></i></a>');
                }
            }
        }
    }

    // 初期設定
    $('.auto-resize').each(function() {
        changeHeight($(this));
    });
    $('.auto-resize').on('change keyup keydown paste cut', function() {
        changeHeight($(this));
    });

    // 行数表示を自動変更
    function changeHeight(obj)
    {
        obj.height('auto');
        // 高さを微調整して表示を自動変更
        obj.height(obj.get(0).scrollHeight - 6);
    }
});
